/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webParsePostWebTomarkdownAsync } from "../../funcs/webParsePostWebTomarkdownAsync.js";
import { PostWebTomarkdownAsyncRequest$zodSchema } from "../../models/postwebtomarkdownasyncop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostWebTomarkdownAsyncRequest$zodSchema,
};

export const tool$webParsePostWebTomarkdownAsync: ToolDefinition<typeof args> =
  {
    name: "web-parse-post-web-tomarkdown-async",
    description: `网页转 Markdown

想把一个网页的内容转成干净的 Markdown 文本？这个异步接口可以帮你搞定，特别适合处理大型或复杂的网页。

## 功能概述

> [!VIP]
> 本 API 目前处于**限时免费**阶段，未来将转为付费服务。

提交一个网页 URL，我们会自动抓取主体内容，剔除广告、导航栏等干扰元素，并转换为 Markdown 格式。同时会提取标题、作者、发布日期等元数据，生成 YAML Front Matter。

任务提交后会立即返回任务 ID，你可以用它来查询处理进度和结果。单个任务最长处理 60 秒，结果缓存 30 分钟。`,
    scopes: ["read", "write"],
    annotations: {
      "title": "",
      "destructiveHint": false,
      "idempotentHint": false,
      "openWorldHint": true,
      "readOnlyHint": false,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await webParsePostWebTomarkdownAsync(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
